<template>
	<card header-classes="bg-dark">
		<template slot="header">
			<h3 class="mb-0 text-white">ตั้งค่าเติมเงินทรูมันนี่วอลเล็ทด้วย QR Code</h3>
		</template>
		<template>
			<div class="setting-truewallet-deposit-info">
				** บัญชีธนาคารที่ใช้ต้องลงทะเบียนพร้อมเพย์ด้วยเบอร์โทรศัพท์ **
			</div>
			<form @submit.prevent="saveSetting">
				<base-input label="บัญชี">
					<el-select v-model="data.accountNumber" placeholder="บัญชีธนาคาร">
						<el-option label="--- เลือกบัญชี ---" value="" />
						<el-option
							v-for="v in scbAccounts"
							:key="v.accountNumber"
							:label="`${v.accountName} - ${v.accountNumber}`"
							:value="v.accountNumber"
						/>
					</el-select>
				</base-input>
				<base-input label="เบอร์โทรศัพท์" placeholder="เบอร์โทรศัพท์" v-model="data.phoneNumber" />

				<div class="mt-3">
					<base-button native-type="submit" type="default" :disabled="loading">
						บันทึกข้อมูล
					</base-button>
				</div>
			</form>
		</template>
	</card>
</template>

<script>
import { Select, Option } from 'element-ui'

import api from '../../services'

export default {
	props: ['withdrawAccount', 'scbAccounts'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			data: {
				accountNumber: '',
				phoneNumber: '',
			},
		}
	},
	methods: {
		async saveSetting() {
			this.loading = true

			try {
				const res = await api.patch('/truewallet-qr-deposit', this.data)

				this.$notify({
					type: 'success',
					message: res.message,
				})
			} catch ({ message }) {
				this.$notify({
					type: 'danger',
					message: message,
				})
			} finally {
				this.loading = false
			}
		},
	},
	async created() {
		try {
			const res = await api.get('/truewallet-qr-deposit')

			this.data = res.data
		} catch ({ message }) {
			this.$notify({
				type: 'danger',
				message: message,
			})
		}
	},
}
</script>
